module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/TaskItemTooltip/images/icon-attention.82e939b3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/TaskItemTooltip/images/icon-attention.png
// module id = 2946
// module chunks = 11